import React from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import './CommandBridge.css';

/**
 * Akkordeon-Sektion der Kommandobrücke in offener Typografie: beschriftete
 * Zeile (Label links, Wert + Aktionen + Chevron rechts), Inhalt ohne Rahmen
 * direkt auf dem Seitengrund, Haarlinie als Abschluss. Ohne onToggle: reine
 * Info-Zeile.
 * `actions` (optional): interaktive Elemente (z.B. `InfoHint`) neben dem
 * Toggle-Button — als Geschwister, nicht als Kind, damit kein `<button>` im
 * `<button>` landet (Radix-Popover-Trigger sind selbst Buttons). Der Chevron
 * sitzt aus demselben Grund außerhalb des Toggles: ein rein dekoratives
 * (`aria-hidden`) Element hinter `actions`, damit die Lesereihenfolge rechts
 * immer Wert → Aktionen → Chevron bleibt, unabhängig davon ob `actions`
 * gesetzt ist. Der Toggle selbst trägt weiterhin `onClick`/`aria-expanded`
 * und deckt visuell die ganze übrige Zeile ab (Klick überall außer auf einer
 * `actions`-Aktion öffnet/schließt).
 * Der Auf/Zu-Chevron erscheint nur, wenn `children` vorhanden ist — Zeilen ohne
 * Inhalt (Navigation zu einer anderen Seite, Sprung zu einem Anker) nutzen
 * `onToggle` für diese Aktion statt für ein Akkordeon und tragen ihr eigenes
 * Richtungssymbol im `value`.
 */
export default function BridgeSection({ label, value, open = false, onToggle, actions, children }) {
  const Head = onToggle ? 'button' : 'div';
  const showChevron = Boolean(onToggle && children);
  return (
    <div className="bridge-section">
      <div className="bridge-section__head">
        <Head
          type={onToggle ? 'button' : undefined}
          className="bridge-section__toggle"
          onClick={onToggle}
          aria-expanded={showChevron ? open : undefined}
        >
          <span className="bridge-section__label">{label}</span>
          <span className="bridge-section__value">{value}</span>
        </Head>
        {actions && <span className="bridge-section__actions">{actions}</span>}
        {showChevron && (
          <span className="bridge-section__chevron" aria-hidden>
            {open ? <ChevronUp size={13} /> : <ChevronDown size={13} />}
          </span>
        )}
      </div>
      {open && children && <div className="bridge-section__body">{children}</div>}
    </div>
  );
}

BridgeSection.Static = function BridgeSectionStatic({ children }) {
  return <div className="bridge-section bridge-section--static">{children}</div>;
};
